import React from "react";

export const PrejuridicoProcessContext = React.createContext();